import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClient, TouchpointInfo, CreateTouchpointRequest, TouchpointType } from '../sdk/sdk';

@Injectable({
  providedIn: 'root',
})
export class TouchpointService {
  private readonly sdk = inject(ApiClient);

  getTouchpoints(opportunityId: string, type?: TouchpointType): Observable<TouchpointInfo[]> {
    return this.sdk.getTouchpoints(opportunityId, type);
  }

  createTouchpoint(request: CreateTouchpointRequest): Observable<TouchpointInfo> {
    return this.sdk.createTouchpoint(request);
  }
}
